import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BackButton',
  props: {
    label: null,
    disabled: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
  label?: string
  disabled?: boolean
}





const onClick = () => {
  if (props.disabled) return
  emit('click')
}

return { __sfc: true,props, emit, onClick }
}

})